import Axios from 'axios'
import Cookies from 'js-cookie'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  MessageBox,
  Message
} from 'element-ui'

// Axios简单配置
Axios.defaults.timeout = 1000 * 60 * 10;
Axios.defaults.baseURL = process.env.VUE_APP_BASE_API

// NProgress简单配置
NProgress.configure({ showSpinner: false })

// 请求拦截器（请求之前所做操作）
Axios.interceptors.request.use(
  async config => {
    NProgress.start()
    Axios.defaults.authorization = Cookies.get('token') || '';// 获取token
    // 没有tokens存储则需要重新登录
    if (!window.location.href.includes('/auth') && !Cookies.get('token')) {
      window.location.href = '/auth_login'
    }
    config.headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    if (Axios.defaults.authorization) {
      config.headers.Authorization = Axios.defaults.authorization
    }
    return config;
  },
  error => {
    NProgress.done()
    return Promise.reject(error);
  }
);
// 响应拦截器即异常处理
Axios.interceptors.response.use(response => {
  NProgress.done()
  // 文件流
  if (response.config.responseType === 'blob') {
    return response
  }
  // 响应码
  if (response && response.data.code === 200) {
    return response;
  } else {
    if (response.data.code === 401) {
      MessageBox.confirm(
        '登录已过期',
        '系统提示',
        {
          confirmButtonText: '重新登录',
          type: 'warning'
        }
      ).then(() => {
        window.location.href = '/auth_login'
      })
    } else {
      // 后端返回的错误信息字段为 msg（部分老接口为 message），避免显示 undefined
      Message.warning(response.data.msg || response.data.message || '服务器忙');
    }
    return Promise.reject(response);
  }
}, err => {
  NProgress.done()
  if (err && err.response) {
    // 后端返回的错误信息字段为 msg（部分老接口为 message），data 可能为 null，需判空避免显示 undefined
    const resData = err.response.data || {};
    const errMes = resData.msg || resData.message || (typeof resData.data === 'string' ? resData.data : '');
    switch (resData.code) {
      case 400:
        Message.error(errMes || '错误请求');
        break;
      case 401:
        MessageBox.confirm(
          '登录已过期，请重新登录',
          '系统提示',
          {
            confirmButtonText: '重新登录',
            type: 'warning'
          }
        ).then(() => {
          window.location.href = '/auth_login'
        })
        break;
      case 403:
        Message.error(errMes || '拒绝访问');
        break;
      case 404:
        Message.error(errMes || '请求错误,未找到该资源');
        break;
      case 405:
        Message.error(errMes || '请求方法未允许');
        break;
      case 406:
        Message.error(errMes || '请求方法不被接受');
        break;
      case 408:
        Message.error(errMes || '请求超时');
        break;
      case 500:
        Message.error(errMes || '服务器端出错');
        break;
      case 501:
        Message.error(errMes || '网络未实现');
        break;
      case 502:
        Message.error(errMes || '网络错误');
        break;
      case 503:
        Message.error(errMes || '服务升级中');
        break;
      case 504:
        Message.error(errMes || '网络超时');
        break;
      case 505:
        Message.error(errMes || 'http版本不支持该请求');
        break;
      default:
        Message.error(errMes || `连接错误${err.response.status}`);
        break;
    }
    return Promise.reject(err)
  } else {
    Message.error('网络超时');
  }
  return Promise.reject(err)
});

/**
 * 封装get方法
 * @param {string} url - 接口地址
 * @param {object} params = {} - 接口参数
 * @returns {*} Promise
 */

export function get (url, params = {}) {
  return new Promise((resolve, reject) => {
    Axios.get(url, {
      params: params
    })
      .then(response => {
        if (response.data.code === 200) {
          resolve(response.data.data)
        } else {
          reject(response.data)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装delete方法
 * @param {string} url - 接口地址
 * @param {object} params = {} - 接口参数
 * @returns {*} Promise
 */

export function del (url, params = {}) {
  return new Promise((resolve, reject) => {
    Axios.delete(url, {
      params: params
    })
      .then(response => {
        if (response.data.code === 200) {
          resolve(response.data.data)
        } else {
          reject(response.data)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 封装delete方法
 * @param {string} url - 接口地址
 * @param  data - 接口参数
 * @returns {*} Promise
 */

export function delBody (url, data) {
  return new Promise((resolve, reject) => {
    Axios.delete(url, {
      data: data
    })
      .then(response => {
        if (response.data.code === 200) {
          resolve(response.data.data)
        } else {
          reject(response.data)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param {string} url - 接口地址
 * @param {object} data = {} - 接口参数
 * @returns {*} Promise
 */

export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    Axios.post(url, data)
      .then(response => {
        if (response.data.code === 200) {
          resolve(response.data.data)
        } else {
          reject(response.data)
        }
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装postQuery请求
 * @param {string} url - 接口地址
 * @param {object} params = {} - 接口参数
 * @returns {*} Promise
 */

export function postQuery (url, params = {}) {
  return new Promise((resolve, reject) => {
    Axios.post(url, {}, {
      params: params
    })
      .then(response => {
        if (response.data.code === 200) {
          resolve(response.data.data)
        } else {
          reject(response.data)
        }
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装patch请求
 * @param {string} url - 接口地址
 * @param {object} data = {} - 接口参数
 * @returns {*} Promise
 */

export function patch (url, data = {}) {
  return new Promise((resolve, reject) => {
    Axios.patch(url, data)
      .then(response => {
        if (response.data.code === 200) {
          resolve(response.data.data)
        } else {
          reject(response.data)
        }
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param {string} url - 接口地址
 * @param {object} data = {} - 接口参数
 * @returns {*} Promise
 */

export function put (url, data = {}, config) {
  return new Promise((resolve, reject) => {
    Axios.put(url, data, config)
      .then(response => {
        if (response.data.code === 200) {
          resolve(response.data.data)
        } else {
          reject(response.data)
        }
      }, err => {
        reject(err)
      })
  })
}
